import type * as React from 'react';
import { get } from '@Domain/Api';
import staffFunctionsFetched, {
	type StaffFunctionsFetchedAction,
	type StaffFunctionsFetchedPayload,
} from '@Application/Facilities/StaffMembers/StaffFunctions/Actions/staffFunctionsFetched';
import staffFunctionsFetchFailed, {
	type StaffFunctionsFetchFailedAction,
} from '@Application/Facilities/StaffMembers/StaffFunctions/Actions/staffFunctionsFetchFailed';
import type FetchStaffFunctions from '@Application/Facilities/StaffMembers/StaffFunctions/Queries/FetchStaffFunctions';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = StaffFunctionsFetchedAction | StaffFunctionsFetchFailedAction;

export default (_query: FetchStaffFunctions) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<StaffFunctionsFetchedPayload>(
				`${parameters.api.host}/api/enums/staff-functions`,
			);

			const action = staffFunctionsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = staffFunctionsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
